<form *ngIf="returnOrder">
    <div *ngFor="let group of skusGroup" class="border p-1 rounded mb-2">
        <div class="d-flex align-items-center gap-3">
            <img [src]="getProductImage(group.productInfo)" class="img-fluid" style="width: 4rem;"
                [alt]="group.productInfo?.name ?? group.productSku"  loading="lazy" />
            <div class="font-bold mb-2 h4">
                Sản phẩm: {{ group.productInfo?.name ?? group.productSku }}
                <div *ngIf="group.expiredDate && group.expiredDate.trim()" style="font-size: 0.85em; font-weight: normal;" class="text-muted mt-1">
                    Hạn dùng: {{ group.expiredDate }}
                </div>
                <div *ngIf="group.combo_Info" class="product_combo">
                    <b>(Sản phẩm thuộc combo: {{group.combo_Info.name}})</b>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-auto border-collapse w-100">
                <thead>
                    <tr class="bg-gray-100">
                        <th class="border p-1">Mã phiếu xuất</th>
                        <th class="border p-1">Lot</th>
                        <th class="border p-1">Giá mua</th>
                        <th class="border p-1">SL giao</th>
                        <th class="border p-1" width="20%">SL trả</th>
                        <th class="border p-1" width="20%">Ghi chú</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let s of group.shipments">
                        <td class="border p-1">
                            <p><strong>{{ s.shipmentCode }}</strong>&nbsp;<span>({{ s.shipmentDate | date: 'dd-MM-yyyy'
                                    }})</span></p>

                        </td>
                        <td class="border p-1">{{ s.lotNumber }}</td>
                        <td class="border p-1">{{ s.price | currencySymbol}}</td>
                        <td class="border p-1 text-center">{{ s.quantity }}</td>
                        <td class="border p-1">
                            <input type="number" [(ngModel)]="s.selectedQuantity" [ngModelOptions]="{standalone: true}"
                                [placeholder]="'Tối đa: ' + s.quantity" [max]="s.quantity" min="0"
                                class="border px-2 py-1 w-20 form-control" />
                        </td>
                        <td class="border p-1">
                            <textarea type="text" rows="2" [(ngModel)]="s.note" [ngModelOptions]="{standalone: true}" placeholder="Lý do trả..."
                                class="border px-2 py-1 w-full form-control"></textarea>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="form-group">
        <label for="note"><strong>Ghi chú</strong></label>
        <textarea id="note" class="form-control" rows="2" [(ngModel)]="returnOrder.reason" [ngModelOptions]="{standalone: true}"></textarea>
    </div>
    <div class="d-flex justify-content-end gap-3 mt-3">
        <app-button (click)="returnCancel()" [type]="'button'" [id]="'btn-cancel'" [class]="'btn btn-md fw-bold'">
            <i class="ri-close-line"></i> Hủy
        </app-button>
        <app-button (click)="createReturnRequest()" [type]="'button'" [id]="'btn-submit'"
            [class]="'btn theme-bg-color btn-md fw-bold text-light'">
            <i class="ri-add-box-line"></i> Tạo Phiếu
        </app-button>
    </div>
</form>